export default __webpack_public_path__ + "static/cartaz-78f5a670edf9670a66a88bf2bca9a1cc.jpg";